import { searchReducer as search } from '../../../features/search/search-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
export function buildCoreQueryError(engine) {
    if (!loadQueryErrorReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const getState = () => engine.state;
    return {
        ...controller,
        get state() {
            return {
                hasError: getState().search.error !== null,
                error: getState().search.error,
            };
        },
    };
}
function loadQueryErrorReducers(engine) {
    engine.addReducers({ search });
    return true;
}
